import { Grid, Breadcrumbs, Link, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { DatePickerTextFiled } from "./TextField";
import {
  startDateChange,
  endDateChange,
} from "../redux/OrderHistory/historyActionCreators";
import {
  startDateChanged,
  endDateChanged,
} from "../redux/General/clientSideSearchActionCreators";
import Store from "../redux/Store";
const HeaderRouter = (props) => {
  const {
    location: { pathname },
    history,
  } = props;
  const pathnames = pathname.split("/").filter((x) => x);

  const fRouteTitle = routerLinks.find((item, index) => {
    return item.link === pathnames[pathnames.length - pathnames.length];
  });

  return (
    <Grid
      container
      item
      xs={12}
      spacing={2}
      justifyContent="space-between"
      style={{ margin: "auto" }}
    >
      <Grid
        container
        item
        xs={12}
        sm={6}
        alignItems="flex-start"
        direction="column"
        justifyContent="flex-start"
      >
        <Typography variant="h6">
          {fRouteTitle !== undefined ? fRouteTitle.title : "پیشخوان"}
        </Typography>
        <Breadcrumbs aria-label="breadcrumb">
          {pathnames.map((name, index) => {
            const RouteTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const route = routerLinks.find((item) => item.link === name);
            const isLast = index === pathnames.length - 1;

            return isLast || index === 0 ? (
              <Typography key={index} variant="body1">
                {route !== undefined ? route.subTitle : name}
              </Typography>
            ) : (
              <Link
                style={{ cursor: "pointer" }}
                key={index}
                onClick={() => {
                  history.push(RouteTo);
                }}
              >
                {route !== undefined ? route.subTitle : name}
              </Link>
            );
          })}
        </Breadcrumbs>
      </Grid>

      <Grid
        item
        container
        justifyContent="space-between"
        direction="row"
        alignItems="flex-end"
        sm={12}
        md={5}
        xs={12}
        lg={5}
        xl={4}
      >
        <Grid item>
          <Typography variant="subtitle2">از تاریخ</Typography>
          <DatePickerTextFiled
            changeHandler={searchChangeHandler}
            action={
              pathnames[pathnames.length - 1] === "history"
                ? startDateChange
                : startDateChanged
            }
            defaultValue={""}
          />
        </Grid>
        <Grid item>
          <Typography variant="subtitle2">تا تاریخ</Typography>
          <DatePickerTextFiled
            changeHandler={searchChangeHandler}
            action={
              pathnames[pathnames.length - 1] === "history"
                ? endDateChange
                : endDateChanged
            }
            defaultValue={new Date().toJSON()}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withRouter(HeaderRouter);

const routerLinks = [
  { title: "پیشخوان", subTitle: "پیشخوان", link: "" },
  { title: "سفارش ها", subTitle: "سفارش ها", link: "orders" },
  { subTitle: "سفارش های جدید", title: "سفارش های جدید", link: "newOrders" },
  { subTitle: "آماده ارسال", title: "آماده ارسال", link: "readyToSend" },
  { subTitle: "تاریخچه", link: "history", title: "تاریخچه" },
  {
    title: "مدیریت کارمندها",
    subTitle: "مدیریت سیستم",
    link: "system-manegment",
  },
  { subTitle: "فهرست کارمندها", title: "مدیریت کارمند ها", link: "employees" },
  {
    subTitle: "دسترسی ها",
    title: "مدیریت گروه کاربران",
    link: "accessibilities",
  },
  { subTitle: "کارمند جدید", title: "کارمند جدید", link: "newEmployeeForm" },
  { subTitle: "کارمند جدید", title: "کارمند جدید", link: "newEmployeeShow" },
  {
    subTitle: "مدیریت گروه کاربران",
    title: "مدیریت گروه کاربران",
    link: "users-group",
  },
  {
    subTitle: "گروه کاربران جدید",
    title: "گروه کاربران جدید",
    link: "new-group",
  },
  {
    subTitle: "مدیر",
    title: "",
    link: "manager",
  },
  {
    subTitle: "کارمند",
    title: "",
    link: "employee",
  },
  {
    subTitle: "تراکنش ها",
    title: "مالی",
    link: "transactions",
  },
  {
    subTitle: "پروفایل من",
    title: "پروفایل من",
    link: "profile",
  },
  {
    subTitle: "مشخصات فردی",
    title: "مشخصات فردی",
    link: "personal-info",
  },
  {
    subTitle: "مشخصات دفتر",
    title: "مشخصات دفتر",
    link: "office-info",
  },
];

const searchChangeHandler = (value, action) => {
  Store.dispatch(action(value));
};
